const experianServiceNames = {
  ID_VERIFICATION: ["uk-idv", "uk-idverify"],
  PEP_SANCTIONS: ["uk-pepsanc", "watchlist", "watchlistscreening"],
  CREDIT_REFERENCE: ["uk-crpverify", "uk-crp"],
  CONTRAS: ["uk-contras"],
};
export default experianServiceNames;
